import { useState } from 'react';

import LabelContainer from '../label-container';
import ErrorContainer from '../error-container';

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

export default function InputsDate({
    label,
    value = new Date(),
    onChange = () => {},
    errors,
    dateProps = {},
}) {
    return (
        <LabelContainer label={label}>
            <ErrorContainer errors={errors}>
                <DatePicker selected={value} onChange={onChange} { ...dateProps }/>
            </ErrorContainer>
        </LabelContainer>
    )
}